/* INDILOOM THEME | cart-page.js  (cart page only: auto update quantities + discount codes) */
(function () {
  'use strict';
  var page = document.querySelector('[data-cart-page]');
  if (!page) return;
  var form = document.getElementById('il-cart-form');
  var t;
  form.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-qty]')) return;
    clearTimeout(t);
    t = setTimeout(function () { form.querySelector('[name="update"]').click(); }, 450);
  });
  function codes() { return (page.getAttribute('data-codes') || '').split(',').filter(Boolean); }
  function update(list, tried) {
    page.classList.add('is-busy');
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (tried) {
          var ok = (c.discount_codes || []).some(function (d) { return d.code.toUpperCase() === tried.toUpperCase() && d.applicable; });
          if (!ok) {
            try { sessionStorage.setItem('il-cp-msg', tried.toUpperCase() + ' is not valid for this cart'); } catch (e) {}
          }
        }
        window.location.reload();
      })
      .catch(function () { page.classList.remove('is-busy'); if (window.ilToast) window.ilToast('Could not apply the code'); });
  }
  page.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cp-apply]'), r = e.target.closest('[data-cp-rm-code]');
    if (a) { var c = a.getAttribute('data-cp-apply'), l = codes(); if (l.indexOf(c) < 0) l.push(c); update(l, c); }
    if (r) { var x = r.getAttribute('data-cp-rm-code').toUpperCase(); update(codes().filter(function (v) { return v.toUpperCase() !== x; })); }
  });
  var cf = page.querySelector('[data-cp-code-form]');
  if (cf) cf.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = cf.querySelector('input').value.trim();
    if (!v) return;
    var l = codes(); if (l.indexOf(v) < 0) l.push(v);
    update(l, v);
  });
  try {
    var m = sessionStorage.getItem('il-cp-msg'), el = document.getElementById('il-cp-msg');
    if (m && el) { el.hidden = false; el.className = 'il-coupon-msg is-error'; el.textContent = m; }
    sessionStorage.removeItem('il-cp-msg');
  } catch (e) {}
})();
